module.exports = __webpack_public_path__ + "static/media/cg3.c4d33062.jpg";